import React, { useMemo, useState } from 'react';
import { clinicalData } from '../data/clinicalData';
import { EmptyState } from './EmptyState';
import { ProtocolResult } from './ProtocolResult';
export function ClinicalDatabase() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProtocolId, setSelectedProtocolId] = useState<string | null>(null);
  const [loadedProtocolId, setLoadedProtocolId] = useState<string | null>(null);
  const filteredProtocols = useMemo(() => {
    const term = searchTerm.toLowerCase();
    return clinicalData.filter(p => p.title.toLowerCase().includes(term) || p.sick.toLowerCase().includes(term) || p.theory.toLowerCase().includes(term));
  }, [searchTerm]);
  const loadedProtocol = useMemo(() => {
    return clinicalData.find(p => p.id === loadedProtocolId) || null;
  }, [loadedProtocolId]);
  const handleLoad = () => {
    if (selectedProtocolId) {
      setLoadedProtocolId(selectedProtocolId);
    }
  };
  return <div className="flex flex-col gap-6 md:grid md:grid-cols-[400px_1fr] md:gap-8 md:items-start animate-fade" data-id="element-8">
      {/* Left Panel */}
      <div className="md:sticky md:top-6 bg-bg1 border border-border rounded-[10px] overflow-hidden shadow-md" data-id="element-9">
        <div className="py-4 px-4 md:py-5 md:px-6 border-b border-border" data-id="element-10">
          <div className="font-sans text-[0.8rem] font-extrabold tracking-[0.1em] uppercase text-teal mb-3 md:mb-4 flex items-center gap-2 after:content-[''] after:flex-1 after:h-px after:bg-border" data-id="element-11">
            1. Search Symptoms & Protocols
          </div>
          <div className="flex flex-col gap-2 mb-2 md:mb-4" data-id="element-12">
            <input type="text" placeholder="e.g., fibromyalgia, heat, shen, migraine..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="p-3 rounded-md border border-border text-[0.95rem] w-full bg-white transition-colors duration-200 focus:outline-none focus:border-teal focus:ring-[3px] focus:ring-teal-p" data-id="element-13" />
          </div>
        </div>

        <div className="py-4 px-4 md:py-5 md:px-6" data-id="element-14">
          <div className="font-sans text-[0.8rem] font-extrabold tracking-[0.1em] uppercase text-teal mb-3 md:mb-4 flex items-center gap-2 after:content-[''] after:flex-1 after:h-px after:bg-border" data-id="element-15">
            2. Select Protocol
          </div>
          <div className="flex flex-col gap-2 mb-3 md:mb-4" data-id="element-16">
            <div className="h-[320px] md:h-[480px] overflow-y-auto border border-border rounded-md bg-white custom-scrollbar" data-id="element-17">
              {filteredProtocols.map(p => <div key={p.id} onClick={() => setSelectedProtocolId(p.id)} onDoubleClick={() => {
              setSelectedProtocolId(p.id);
              setLoadedProtocolId(p.id);
            }} className={`p-2.5 cursor-pointer text-[0.9rem] md:text-[0.95rem] transition-colors ${selectedProtocolId === p.id ? 'bg-teal text-white' : 'hover:bg-bg2 text-ink'}`} data-id="element-18">
                  {p.title}
                </div>)}
              {filteredProtocols.length === 0 && <div className="p-4 text-center text-muted italic" data-id="element-19">
                  No protocols found matching "{searchTerm}"
                </div>}
            </div>
          </div>
          <button onClick={handleLoad} disabled={!selectedProtocolId} className="p-3.5 bg-gradient-to-br from-teal to-teal-l text-white border-none rounded-md font-bold cursor-pointer transition-all duration-200 w-full mt-1 shadow-teal-btn hover:-translate-y-px hover:shadow-teal-btn-hover disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:transform-none disabled:hover:shadow-teal-btn" data-id="element-20">
            Load Treatment Protocol
          </button>
        </div>
      </div>

      {/* Right Panel */}
      <div className="min-h-[300px] md:min-h-[600px] bg-bg1 border border-border rounded-[10px] overflow-hidden shadow-md" data-id="element-21">
        {loadedProtocol ? <ProtocolResult protocol={loadedProtocol} data-id="element-22" /> : <EmptyState icon="☯" title="No Protocol Selected" subtitle="Search and select a clinical protocol from the left menu to view Dr. Tan's diagnosis, theory, and exact point prescriptions." data-id="element-23" />}
      </div>
    </div>;
}